import * as React from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Placement } from 'popper.js';
import { ComponentHelpers } from './ComponentHelpers';

export interface IOverlayPopoverProps {
  header: string | React.ReactNode;
  body: string | React.ReactNode;
  trigger?: 'mouse-over' | 'click';
  placement?: Placement;
  containerStyle?: React.CSSProperties;
  popoverClassName?: string;
  boundariesElement?: HTMLElement;
  children?: React.ReactNode;
}

interface IOverlayPopoverState {
  isOpen: boolean;
}

export class OverlayPopover extends React.Component<
  IOverlayPopoverProps,
  IOverlayPopoverState
> {
  private static componentTypeId =
    'popover' + ComponentHelpers.getGuid().replace('-', '');
  private static tooltipCounter = 0;
  private id = OverlayPopover.componentTypeId + OverlayPopover.tooltipCounter++;

  constructor(props: IOverlayPopoverProps, state: IOverlayPopoverState) {
    super(props, state);
    this.state = { isOpen: false };
  }

  public render() {
    var mouseOverTrigger =
      !this.props.trigger || this.props.trigger == 'mouse-over';
    return (
      <div
        id={this.id}
        style={
          this.props.containerStyle
            ? { display: 'inline-block', ...this.props.containerStyle }
            : { display: 'inline-block' }
        }
        onMouseDown={
          !mouseOverTrigger ? () => this.setState({ isOpen: true }) : undefined
        }
        onMouseEnter={
          mouseOverTrigger ? () => this.setState({ isOpen: true }) : undefined
        }
        onMouseLeave={
          mouseOverTrigger ? () => this.setState({ isOpen: false }) : undefined
        }
      >
        {this.props.children}
        <Popover
          placement={this.props.placement}
          delay={0}
          container="body"
          boundariesElement={this.props.boundariesElement}
          className={this.props.popoverClassName}
          isOpen={this.state.isOpen}
          target={'#' + this.id}
          toggle={() => this.setState({ isOpen: false })}
        >
          <PopoverHeader>{this.props.header}</PopoverHeader>
          <PopoverBody>{this.props.body}</PopoverBody>
        </Popover>
      </div>
    );
  }
}
